import { render, staticRenderFns } from "./AutoPriceList.vue?vue&type=template&id=03db5bb0&scoped=true&"
import script from "./AutoPriceList.vue?vue&type=script&lang=js&"
export * from "./AutoPriceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03db5bb0",
  null
  
)

export default component.exports